module.exports = __webpack_public_path__ + "img/wastebasket.9e8599fb.png";